import { LOCALES } from '../../locales';

const current_year = new Date().getFullYear();

export const generalFormI18n = {
  [LOCALES.ENG]: {
    generalForm_validation_required: `The {field} field is required`,
    generalForm_validation_range: `The {field} range should be {min}-{max} characters`,
    generalForm_validation_range_for_URL: `Exceeded maximum limit of {max} characters`,
    generalForm_validation_email: `The {field} field must contain a valid email address`,
    generalForm_validation_allowed: `The {field} field contains not allowed symbols`,
    generalForm_validation_uri: `The {field} field must contain a valid URI address`,
    generalForm_validation_uriProtocol: `The {field} field must be started with http:// or https://`,
    generalForm_validation_uriDomain: `The {field} field must contain a valid domain name`,
    generalForm_validation_unique: `The {field} field should be unique`,
    generalForm_validation_lowerCase: `The {field} should contain at least {lowerCase} lower-cased letter(s)`,
    generalForm_validation_upperCase: `The {field} should contain at least {upperCase} upper-cased letter(s)`,
    generalForm_validation_numeric: `The {field} should contain at least {numeric} number(s)`,
    generalForm_validation_symbol: `The {field} should contain at least {symbol} symbol(s)`,
    generalForm_validation_confirmPassword: `The {field} does not match`,
    generalForm_placeholder_select: `Please select {field}`,
    generalForm_shortDescription_placeholder: `Please enter {field} in 15-250 character range`,
    generalForm_validation_exist: `This {field} already exists`,
    generalForm_validation_find: `We found a user with this e-mail address`,
    generalForm_validation_format: `The {field} must be in a valid format: {format}`,
    generalForm_validation_regEx: `The {field} field can only contain {RegEx} value`,
    registrationForm_phone_validation: `The {field} field can have only {character} digits`,
    shared_copyrights_calendar_year:`${current_year}`,
  },
};
